import { useLanguageStore } from "@/stores/language";
import type { LangLocales } from "@/models/LangLocales";
import type { Sprache } from "@/models/Sprache";
import LanguageController from "@/controller/LanguageController";
import { i18n, setI18nMessages } from "@/i18n";

let langStore: ReturnType<typeof useLanguageStore> | null = null;
function getLangStore() {
  if (!langStore) langStore = useLanguageStore();
  return langStore;
}

/** Locale sicher setzen – funktioniert bei vue-i18n als Ref (legacy:false) und als String (legacy:true) */
function setGlobalLocale(locale: string) {
  const g: any = i18n.global;
  if (typeof g.locale === "string") g.locale = locale; // legacy:true
  else if (g.locale && "value" in g.locale) g.locale.value = locale; // legacy:false
}

export default {
  getLangIdByLocale(locale: LangLocales): string | null {
    const store = getLangStore();
    const entry = Object.entries(store.langIdToLocale).find(
      ([, v]) => v === locale
    );
    return entry ? entry[0] : null;
  },

  setLanguage(langId: string) {
    const store = getLangStore();
    if (langId === store.currentLangId) return;

    if (!store.availableLanguages?.some((l) => l.id === langId)) {
      console.warn(`Language ${langId} not available`);
      langId = store.defaultLanguage.id;
    }

    store.currentLangId = langId;
    localStorage.setItem("currentLangId", langId);

    const locale = store.langIdToLocale[langId];
    if (locale) setGlobalLocale(locale);
  },

  setAvailableLanguages(languages: Sprache[]) {
    const store = getLangStore();
    store.availableLanguages = languages;

    if (
      !store.currentLangId ||
      !languages.some((l) => l.id === store.currentLangId)
    ) {
      store.currentLangId = languages[0]?.id || store.defaultLanguage.id;
      localStorage.setItem("currentLangId", store.currentLangId);
    }
  },

  async setLanguageTexts() {
    const texts = await LanguageController.getSprachtexte();
    Object.entries(texts).forEach(([lang, tr]) => {
      if (tr && Object.keys(tr).length)
        setI18nMessages(lang, tr as Record<string, string>);
    });
  },
};
